function logEvent(eventDescription, additionalParams = {}) {
    gtag("event", eventDescription, additionalParams)
    mixpanel.track(eventDescription, additionalParams)
    ahoy.track(eventDescription, additionalParams)
    posthog.capture(eventDescription, additionalParams)
 }

export { logEvent }
